var render = function render(_c,_vm){return _c('a',{staticClass:"btn-circle",attrs:{"href":"#"},on:{"click":function($event){_vm.listeners.click && _vm.listeners.click()}}},[(_vm.props.icon)?_c('inline-svg',{attrs:{"src":_vm.props.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }